<header class="header">
  <div class="container">
    <div class="header__toolbar">
      <a class="logo header__logo" href="https://ai.aidata.me/?utm_source=aiassistant&utm_medium=site" target="_blank">
        <img
          class="logo__img"
          ngSrc="assets/images/logo.svg"
          alt="Aidata.me"
          height="47"
          width="42"
        />
        <span class="logo__title">AiData.me</span>
      </a>

      @if (authStore.user(); as user) {
        <button
          class="header__menu-button"
          [(tuiDropdownOpen)]="isHeaderMenuOpen"
          [tuiAppearanceState]="isHeaderMenuOpen ? 'hover' : null"
          [tuiDropdown]="content"
          tuiDropdownLimitWidth="fixed"
          tuiChevron
          tuiButton
          appearance="ai-flat"
        >
          <span>{{ user.username }}</span>
        </button>
        <ng-template #content>
          <tui-data-list tuiAppearance="ai-data-list">
            <button (click)="logout()" tuiOption type="button">Выход из аккаунта</button>
          </tui-data-list>
        </ng-template>
      } @else {
        <button
          class="header__auth-button"
          (click)="openAuthModal()"
          tuiButton
          appearance="ai-primary"
          size="s"
        >
          Авторизоваться
        </button>
      }
    </div>
    <h1 class="title header__title">
      <div>
        Ваш личный
        <img
          class="title__image"
          src="assets/images/ai-asisstant/ai-asisstant.png"
          srcset="
            assets/images/ai-asisstant/ai-asisstant.png    1x,
            assets/images/ai-asisstant/ai-asisstant@2x.png 2x
          "
          alt="Ai ассистент"
        />
        Ai-ассистент<br />
        в мире готовых аудиторий
      </div>
    </h1>
  </div>
</header>
<main class="main">
  @if (authStore.user()) {
    <section class="section audience">
      <div class="container section__container">
        <div class="audience__content">
          <h2 class="heading audience__title">Подобрать аудитории</h2>

          <app-audience-form
            [form]="audienceForm"
            [sectors]="sectors$ | async"
            [segments]="segments$ | async"
            [platforms]="platforms"
            [isLoading]="mainLayoutStore.isLoading()"
            (buildAudience)="buildAudience()"
            (openSegmentModal)="openSegmentModal()"
          ></app-audience-form>
        </div>
      </div>
    </section>
  } @else {
    <section class="section auth">
      <div class="container section__container">
        <div class="auth__content">
          <h2 class="auth__title">
            Авторизуйтесь,
            <span>чтобы пользоваться инструментом</span>
            и подбирать аудитории
          </h2>
          <div class="auth__picture">
            <img
              src="assets/images/auth/auth.png"
              srcset="assets/images/auth/auth.png 1x, assets/images/auth/auth@2x.png 2x"
              alt="Авторизуйтесь"
            />
          </div>

          <button
            class="auth__button"
            (click)="openAuthModal()"
            tuiButton
            appearance="ai-primary"
            size="m"
          >
            Авторизоваться
          </button>
        </div>
      </div>
    </section>
  }

  @let isCreatingAiQuestion = this.mainLayoutStore.isCreatingAiQuestion();
  @let activeItemIndex = this.mainLayoutStore.activeItemIndex;

  @let isLoadingFaqQuestions = faqItems.isLoading();
  @let faqQuestions = faqItems.value()?.list || lastFaqQuestions().list;
  @let aiQuestions = aiItems.value()?.list ?? null;

  <section class="section faq">
    <div class="container section__container">
      <div class="faq__content">
        <h2 class="heading faq__title">У нас часто спрашивают</h2>

        <label class="faq__search" [tuiAppearance]="'ai-label'" tuiLabel>
          <span class="ai-label">
            @if (!authStore.isAiShown()) {
              Найдите свой вопрос из FAQ
            } @else {
              Найдите свой вопрос из FAQ или спросите у  <button class="ai-label__link" tuiLink (click)="mainLayoutStore.updateActiveItemIndex(1)">AI-ассистента</button>
            }
          </span>

          <tui-textfield [tuiTextfieldCleaner]="false" tuiTextfieldSize="l">
            <textarea
              [formControl]="selectedQuestion"
              [min]="activeItemIndex() === 0 ? 1 : 5"
              [max]="5"
              [placeholder]="activeItemIndex() === 0 ? 'Найти вопрос' : 'Уточнить вопрос'"
              tuiTextarea
            ></textarea>

            <button
              class="mode"
              [class.mode_is-active]="activeItemIndex() === 0"
              (click)="mainLayoutStore.updateActiveItemIndex(0)"
              appearance="flat"
              size="s"
              tuiButton
              type="button"
              tuiHint="Поиск"
              tuiHintDirection="top"
            >
              <tui-icon icon="@tui.search" />
            </button>

            @if (authStore.isAiShown()) {
              <button
                class="mode"
                [class.mode_is-active]="activeItemIndex() === 1"
                (click)="mainLayoutStore.updateActiveItemIndex(1)"
                appearance="flat"
                size="s"
                tuiButton
                type="button"
                tuiHint="Спросить AI"
                tuiHintDirection="top"
              >
                <tui-icon icon="@tui.brain" />
              </button>
            }
          </tui-textfield>
        </label>

        @if (activeItemIndex() === 0) {
          <app-faq-questions
            [isLoading]="isLoadingFaqQuestions"
            [questions]="faqQuestions"
            [pagesCount]="mainLayoutStore.pagesCount()"
            [currentPage]="mainLayoutStore.currentPage()"
            (changePage)="mainLayoutStore.updateCurrentPage($event + 1)"
          >
          </app-faq-questions>
        } @else {
          <app-ai-questions
            [questions]="aiQuestions"
            [selectedQuestion]="selectedQuestion.value"
            [isCreatingAiQuestion]="isCreatingAiQuestion"
            [isAskAiDisabled]="isAskAiDisabled()"
            (askAi)="askAi()"
            (toggleAiQuestion)="toggleAiQuestion($event)"
            (typingCompleted)="onTypingCompleted($event)"
          ></app-ai-questions>
        }
      </div>
    </div>
  </section>

  <section class="section segments">
    <div class="container section__container segments__container">
      <div class="segments__content">
        <h2 class="segments__title">
          <img
            class="segments__image"
            width="80"
            height="80"
            ngSrc="assets/images/users/users.png"
            srcset="assets/images/users/users.png 1x, assets/images/users/users@2x.png 2x"
            alt="Ai ассистент"
          />

          <div><span>Готовые аудитории</span> на базе AI-технологии</div>
        </h2>

        <a
          class="segments__button"
          href="https://aidata.me/audiences?utm_source=site&utm_medium=cpc&utm_campaign=ai"
          target="_blank"
          tuiButton
          appearance="ai-secondary"
          size="m"
        >
          Подробнее о сегментах
        </a>
      </div>
    </div>
  </section>
</main>
<footer class="footer">
  <div class="container footer__container">
    <a class="logo logo_theme_dark footer__logo" href="https://ai.aidata.me/?utm_source=aiassistant&utm_medium=site" target="_blank">
      <img
        class="logo__img"
        ngSrc="assets/images/logo.svg"
        alt="Aidata.me"
        height="47"
        width="42"
      />
      <span class="logo__title">AiData.me</span>
    </a>
    <div class="legal footer__legal">
      <span class="legal__text">© 2012-2026 All Rights Reserved</span>
      <a class="legal__link" href="https://aidata.me/policy" target="_blank">Privacy policy</a>
    </div>
    <ul class="footer__links">
      <li class="footer__link footer__link_type_vc-ru">
        <a href="https://vc.ru/id887164" target="_blank" aria-label="vc.ru"></a>
      </li>
      <li class="footer__link footer__link_type_rutube">
        <a href="https://rutube.ru/channel/43546547/" target="_blank" aria-label="rutube"></a>
      </li>
      <li class="footer__link footer__link_type_youtube">
        <a href="https://www.youtube.com/@aidata4564" target="_blank" aria-label="youtube"></a>
      </li>
      <li class="footer__link footer__link_type_band-link">
        <a href="https://band.link/DataupDate" target="_blank" aria-label="band.link"></a>
      </li>
      <li class="footer__link footer__link_type_telegram">
        <a href="https://t.me/aidatanews" target="_blank" aria-label="telegram"></a>
      </li>
    </ul>
  </div>
</footer>
